import { Language } from '../../lang/Language'

export class TriedToPlayBlindsOutOfOrderError extends Error {
  constructor() {
    super(Language.strings.error.table.triedToPlayBlindsOutOfOrderError)
  }
}
